import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { StepFunctions } from "../joyrideSteps";
import StartStep from "./StartStep";
import { useState } from "react";
import { Trans } from "react-i18next";

const BookingModalStep: React.FC<StepFunctions> = () => {
    const [showStartStep, setShowStartStep] = useState(false);
    const handleButtonClick = () => setShowStartStep(true);

    return (
        <div className="p-1">
            {showStartStep ? (
                <StartStep setShowStartStep={setShowStartStep} />
            ) : (
                <Row>
                    <Col xs={11}>
                        <p className="mb-0 fs-7">
                            <Trans
                                i18nKey="onlineBooking.enableOptionOnlineBooking"
                                components={{ strong: <strong /> }}
                            />
                        </p>
                    </Col>
                    <Col xs={1} className="p-0 text-center">
                        <Button variant="link" className="p-0" onClick={handleButtonClick}>
                            <i className="bi bi-x-lg "></i>
                        </Button>
                    </Col>
                </Row>
            )}
        </div>
    );
};

export default BookingModalStep;
